export default __webpack_public_path__ + "static/media/body_percentiles_avatar_ball-dark.3b34557a.png";